import { Pipe, PipeTransform } from '@angular/core';
import {AlarmSeverityPipe} from './alarm-severity-pipe';

@Pipe({
  name: 'alarmSeverityTable'
})
export class AlarmSeverityTablePipe implements PipeTransform {

  transform(value: number, row: any): any {

    const severity = new AlarmSeverityPipe().transform(value);
    const fontElement = '<i class="fa fa-square label-' +  severity + '"></i>';
    return '<div title="' + severity + '" class="center-content">' + fontElement + '</div>';
  }

}
